var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-card", {
    staticClass: "empty-card",
    attrs: { "card-header": "" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("file.uploaded")) + "\n      "),
              _c("span", { staticClass: "text-secondary bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("capitalize")(_vm.$tc("global.words.file", 1))
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "bold clickable text-primary",
                class: { disabled: _vm.loading },
                on: { click: _vm.downloadDocument },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("truncateFileName")(_vm.name, 25)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.loading
              ? _c("inline-loader", { staticClass: "ml-1" })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("-")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("momentLocal")(_vm.createdAt, "MMM. DD, YYYY")
                  ) +
                  " @\n      " +
                  _vm._s(_vm._f("momentLocal")(_vm.createdAt, "LT")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }